
import { Outlet, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import axios from 'axios';

export default function Authenticated(){
  // const [loading, setLoading] = useState(true)
  // const [isAuth, setisAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [isAuth, setisAuth] = useState(false)

  useEffect(()=>{
    axios.get('/api/login/status').then(function(res){
      setisAuth(res.data)
      setLoading(false)
    })


  }, [])

    if(loading) return <></>

    return isAuth ? <Outlet/> : <Navigate to="/login"/> 
        
};